import type { SubscriptionViewResponse } from './types';

export async function fetchSubscriptionView(endpoint: string, nonce: string, subscriptionId: number): Promise<SubscriptionViewResponse> {
  const url = new URL(endpoint, window.location.origin);
  url.searchParams.set('id', String(subscriptionId));

  const response = await fetch(url.toString(), {
    credentials: 'same-origin',
    headers: {
      'X-WP-Nonce': nonce,
    },
  });

  if (!response.ok) {
    throw new Error(`Load failed (${response.status})`);
  }

  return (await response.json()) as SubscriptionViewResponse;
}
